import Organization from './organization';
import { User, UserInfo } from './User';

export default class OrganizationRequest {
  organization: Organization;
  user: UserInfo;
  id: string;
}
